module.exports = "https://cdn-assessment.mathletics.com/app/124/assets/images/51c716481b461e39f927db6d83bef306.svg";